import api from "../config/api";
import handleResponse from "./ResponseHandler";

function getInspectionCarbonData(inspectionId: string, idToken: string) {
    return new Promise(function (resolve, reject) {
        const options = {
            method: "get",
            headers: {
                Accept: "application/json, text/plain, */*",
                idtoken: idToken,
                "Content-Type": "application/json"
            }
        };
        fetch(api.getCarbonData + "?id=" + inspectionId.toLowerCase(), options)
            .then((response) => handleResponse(response))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) =>
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
                })
            );
    });
}

export default getInspectionCarbonData;
